import React from "react";

const MetabotLogo = () => <img src="app/assets/img/metabot.svg" />;

export default MetabotLogo;



// WEBPACK FOOTER //
// ./components/MetabotLogo.jsx